import React, { useEffect, useState } from "react";

const UnpublishedNoticeLogo = ({ whiteLabelInfo, brandData }) => {
    const [isWhiteLabel, setIsWhiteLabel] = useState(false);
    const [isBrandingAvailable, setIsBrandingAvailable] = useState(false);
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    const IfpLogo = () => {
        return (
            <a href="https://www.ifloorplan.com" style={{ display: 'flex' }}>
                <img
                    className="classbrandLogo"
                    src="/static/public/img/ifloorplanLogo.png"
                    width="180"
                    style={{
                        alignSelf: 'center',
                        margin: isMobile ? '40px auto 0' : '0',
                    }} />
            </a>
        )
    }

    const BrandingLogo = () => {
        return (
            <a href={'https://' + brandData?.url}>
                <img className="classbrandLogo" src={brandData?.logo} style={{
                    maxHeight: '150px',
                    maxWidth: '300px',
                }} />
            </a>
        )
    }

    useEffect(() => {
        setIsWhiteLabel(whiteLabelInfo ? true : false);
        setIsBrandingAvailable(brandData?.logo ? true : false);
    }, [brandData, whiteLabelInfo]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            width: isMobile  ? '100%' : '70%',
            justifyContent: 'space-around',
            alignSelf: 'center',
        }}>
            {isBrandingAvailable && <BrandingLogo />}
            {!isWhiteLabel && <IfpLogo />}
        </div>
    )
}

export default UnpublishedNoticeLogo;
